var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7391 11.6829C28.9692 10.3498 27.045 10.3498 26.2752 11.6829L7.51262 44.1726C6.74262 45.5059 7.70486 47.1727 9.24456 47.1727H46.7698C48.3095 47.1727 49.2717 45.5059 48.5017 44.1726L29.7391 11.6829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7391 11.6829C28.9692 10.3498 27.045 10.3498 26.2752 11.6829L7.51262 44.1726C6.74262 45.5059 7.70486 47.1727 9.24456 47.1727H46.7698C48.3095 47.1727 49.2717 45.5059 48.5017 44.1726L29.7391 11.6829Z",
    fill: "#FF9800",
    fillOpacity: 0.18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3211 45.0466L32.4117 5.37651C31.9703 4.59088 31.3234 3.93614 30.5402 3.48259C29.372 2.80608 28.0105 2.62512 26.7058 2.97261C25.4012 3.32021 24.3104 4.15472 23.633 5.32381L0.847945 44.7789C-1.39042 48.0806 1.07434 52.6746 5.06734 52.6399H50.9509C51.826 52.6399 52.7006 52.4013 53.4798 51.95C55.8912 50.5538 56.7169 47.4563 55.3211 45.0466ZM52.3835 50.0576C51.9369 50.3162 51.4417 50.4529 50.9498 50.4529H5.06734C2.78883 50.4727 1.39195 47.8425 2.68274 45.9698C2.69728 45.9484 2.71107 45.9264 2.72397 45.9038L25.5266 6.41844C25.9103 5.75604 26.529 5.2827 27.269 5.08577C28.0037 4.88928 28.78 4.98999 29.4438 5.37498C29.8893 5.63303 30.2569 6.00523 30.5067 6.45135C30.509 6.45551 30.5114 6.45977 30.5138 6.46393L53.4274 46.1414C54.2195 47.5088 53.7513 49.2656 52.3835 50.0576Z",
    fill: "#FF9800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3211 45.0466L32.4117 5.37651C31.9703 4.59088 31.3234 3.93614 30.5402 3.48259C29.372 2.80608 28.0105 2.62512 26.7058 2.97261C25.4012 3.32021 24.3104 4.15472 23.633 5.32381L0.847945 44.7789C-1.39042 48.0806 1.07434 52.6746 5.06734 52.6399H50.9509C51.826 52.6399 52.7006 52.4013 53.4798 51.95C55.8912 50.5538 56.7169 47.4563 55.3211 45.0466ZM52.3835 50.0576C51.9369 50.3162 51.4417 50.4529 50.9498 50.4529H5.06734C2.78883 50.4727 1.39195 47.8425 2.68274 45.9698C2.69728 45.9484 2.71107 45.9264 2.72397 45.9038L25.5266 6.41844C25.9103 5.75604 26.529 5.2827 27.269 5.08577C28.0037 4.88928 28.78 4.98999 29.4438 5.37498C29.8893 5.63303 30.2569 6.00523 30.5067 6.45135C30.509 6.45551 30.5114 6.45977 30.5138 6.46393L53.4274 46.1414C54.2195 47.5088 53.7513 49.2656 52.3835 50.0576Z",
    fill: "black",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 17.988,
    width: 5.60001,
    height: 16.7958,
    fill: "#FF9800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 17.988,
    width: 5.60001,
    height: 16.7958,
    fill: "black",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 38.0995,
    width: 5.60001,
    height: 5.59861,
    fill: "#FF9800"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 38.0995,
    width: 5.60001,
    height: 5.59861,
    fill: "black",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.6b5df5480ddaa87663de8d5ab44d6656.svg";